import PropTypes from "prop-types";
import Head from "next/head";
import React from "react";
const Layout = (props) => {
  return (
    <div>
      <Head>
        <title> ERUDITE GLOBAL</title>
        <script src="https://js.stripe.com/v3/" />
      </Head>
      <div style={{ backgroundColor: "rgb(27,60,93)" }}>
        <div>
          <h2
            style={{
              fontFamily: "TimesNewRoman",
              color: "white",
              margin: 0,
              padding: 20,
            }}
          >
            ERUDITE GLOBAL
          </h2>
          <h3
            style={{
              fontFamily: "TimesNewRoman",
              color: "white",
              margin: 0,
              paddingLeft: 20,
              paddingBottom: 10,
            }}
          >
            Registered Migration Agent MARN 1913457
          </h3>
        </div>
      </div>
      <div id="container">{props.children}</div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Layout;
